import React, { useEffect, useState } from 'react';
import Einstellungen from './preferences';
import AdminIframe from './adminiframe';
import { useAuth } from './authcontext';
import { openLoginAsTab } from './_loginasuser';


const Administration = () => {
  const { user } = useAuth();
  const [iframeUrl, setIframeUrl] = useState("");


  
  const loginAsUser = (aml, pml, pg_id) => {
    const form = document.createElement("form");
    form.method = "POST";
    //form.action = `https://${pg_id}.pressewebshop2.de/adminuser`; // adjust domain
    form.action = `http://${pg_id}.localhost:3001/adminuser`; // adjust domain
    form.target = "_blank"; // opens new tab
  
    const addField = (name, value) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = value;
      form.appendChild(input);
    };
  
    addField("aml", aml);
    addField("pml", pml);
    addField("pg_id", pg_id);
  
    document.body.appendChild(form);
    form.submit();
    form.remove();
  };

 

  return (
    <div className="mainContentWrapper">
      <div className="contentContainer">
        <br />
        <h4>Kundenverwaltung</h4>
       
        <br />
        <div className="contentContainer">
          

          {/* Your login-as button 
          <button
                onClick={() => {
                    window.open(
                    `/adminlogin?aml=777777&pml=k4tz3nk4l3nd3r&pg_id=602410`,
                    "_blank"
                    );
                }}
                >
            Test Admin Login
            </button>

        <button onClick={() => openLoginAsTab({ aml: "777777", pml: "k4tz3nk4l3nd3r", pg_id: "602410" })}>
        nutterbutton v2
        </button>
*/}

        

          {/* Pass URL to iframe */}
          <AdminIframe />

        </div>
      </div>
    </div>
  );
};

export default Administration;